<template>
  <Modal
    class="tooltip-modal"
    data-testid="tooltip-modal"
    :is-open="isOpen"
    :show-back-button="false"
    size="md"
    title=""
    @close="handleClose"
  >
    <div class="tooltip-modal__content">
      <Heading class="tooltip-modal__heading" :level="3">
        Descreva o motivo
      </Heading>
      <SingleInput
        v-model="text"
        show-clear-button
        type="text"
        @on-clear="clearText"
      />
    </div>
    <template #buttonContainer>
      <ButtonContainer>
        <ButtonPrimary
          slot="button-primary"
          label="Confirmar"
          :disabled="isSubmitButtonDisabled"
          @click="handleSubmit"
        />
        <ButtonSecondary
          slot="button-secondary"
          label="Cancelar"
          @click="handleClose"
        />
      </ButtonContainer>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';

import {
  Modal,
  Heading,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  SingleInput
} from '@warrenbrasil/nebraska-web';

interface Props {
  isOpen: boolean;
}
defineProps<Props>();

interface Emits {
  (e: 'close'): void;
  (e: 'submit', text: string): void;
}
const emit = defineEmits<Emits>();

const text = ref('');

const isSubmitButtonDisabled = computed(() => {
  return text.value?.length === 0;
});

const clearText = () => {
  text.value = '';
};

const handleSubmit = () => {
  emit('submit', text.value);
};

const handleClose = () => {
  emit('close');
};
</script>

<style lang="less" scoped>
.tooltip-modal {
  ::v-deep .modal-content {
    padding: 0 @size-spacing-x900 @size-spacing-x900 @size-spacing-x900;
  }

  &__heading,
  &__text {
    text-align: left;
  }

  &__heading {
    margin-bottom: @size-spacing-x350;
  }

  &__content {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    flex-direction: column;
  }
}
</style>
